<template>
  <li class="max-w-[400px]">
    <ResponsiveImage :media="content.image" class="w-full object-cover aspect-79/58" />
    <h3 class="text-xl md:text-2xl font-semibold my-5 md:my-[30px]">{{ content.title }}</h3>
    <RawHtml :html="content.description" />
  </li>
</template>
<script lang="ts">
import { ResponsiveImage } from "@/components/helpers";
import { RawHtml } from "@/components/helpers";
export default {
  name: "RichCard",
  components: { ResponsiveImage, RawHtml },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>
